import { seriesLiqui } from "./series"
import { buildBewertungsPlotline, updateBewertungLinie, updateDataGrouping, zoomIn } from "./helpers"

export function buildConfig(chartRiester) {
	const data = chartRiester.data

	return {
		chart: {
			events: {
				selection: function (event) {
					return zoomIn(chartRiester, event)
				},
			},
		},

		xAxis: {
			ordinal: false,
			min: data.startdatum,
			max: data.enddatum,
			plotLines: [
				buildBewertungsPlotline({ bewertungsdatum: data.bewertungsdatum, bewertungswert: data.bewertungswert }),
			].filter(Boolean),
			events: {
				afterSetExtremes: function (event) {
					const chart = event.target.chart
					updateDataGrouping(chart, event.min, event.max)
					updateBewertungLinie(chartRiester)
				},
			},
		},

		yAxis: [
			{},
			{
				opposite: true,
			},
		],

		legend: {
			enabled: true,
			events: {
				itemClick: function (event) {
					const item = event?.legendItem
					const seriesId = item?.options?.id
					if (!seriesId) return true

					const willBeVisible = !item.visible
					chartRiester.onLegendToggle?.(seriesId, willBeVisible)
					return true
				},
			},
		},

		plotOptions: {
			series: {
				point: {
					events: {
						click: function () {
							chartRiester.openDetailansicht(this.x)
						},
					},
				},
				cursor: "pointer",
			},
			area: {
				stacking: "normal",
			},
		},

		series: seriesLiqui(data),
	}
}
